import { useState } from 'react';
import { HsnSearchDesktop } from './SearchDesktopTable';
import { HsnSearchMobile } from './SearchMobileTable';
import { IHsnDataCollection } from './Service/hsn.service';

export interface IHsnProps {
  results: IHsnDataCollection;
}
export const HsnSearch = ({ results }: IHsnProps): JSX.Element => {
  const [type, setType] = useState<keyof IHsnDataCollection>('hsn');
  const [selectedChapterMobile, setSelectedChapterMobile] =
    useState<string>('all');

  return (
    <div>
      <div className="flex-row inline-flex justify-center mt-8 shadow-sm text-center w-full">
        <div
          className={` font-semibold pb-4 px-14  text-s-20 sm:text-base cursor-pointer ${
            type == 'hsn' ? 'border-b-2 border-blue-350 text-blue-350' : ''
          }`}
          onClick={() => {
            setType('hsn');
            setSelectedChapterMobile('all');
          }}
        >
          HSN({Object.keys(results.hsn).length})
        </div>
        <div
          className={` font-semibold pb-4 px-14 text-s-20 sm:text-base cursor-pointer ${
            type == 'sac' ? 'border-b-2 border-blue-350 text-blue-350' : ''
          }`}
          onClick={() => {
            setType('sac');
            setSelectedChapterMobile('all');
          }}
        >
          SAC({Object.keys(results.sac).length})
        </div>
      </div>
      <HsnSearchDesktop results={results} type={type} />
      <HsnSearchMobile
        results={results}
        type={type}
        selectedChapterMobile={selectedChapterMobile}
        setSelectedChapterMobile={setSelectedChapterMobile}
      />
    </div>
  );
};
